var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wh100",attrs:{"id":"app"}},[(!_vm.isOpen)?_c('div',{staticClass:"closed fixed wh100 left0 top0 flex-center z999"},[_c('div',[_vm._v(" Program: 20:00 - 01:00 ")])]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }